<img src="./assets/images/jovacopop.svg" />

<p class="version-title">
  <i class="far fa-question-circle"></i>
  <span translate="VERSION.TITLE"></span>
</p>
<table *ngIf="version"
       class="font-normal">
  <tr *ngFor="let versionItem of version | keyvalue">
    <td [translate]="'VERSION.'+ (versionItem.key | uppercase)"></td>
    <td>{{versionItem.value}}</td>
  </tr>
</table>
